import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { SuperComponent } from '../../super/super.component';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { publicSettingService } from 'src/app/shared/services/hr/publicSetting';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { TranslateService } from '@ngx-translate/core';
import { NotifyService } from 'src/app/shared/services/hr/notify.service';
import { EmployeeService } from 'src/app/shared/services/hr/employee.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { CellGridInfo } from 'devexpress-richedit/lib/core/model/tables/grid/table-cell-grid-info';

@Component({
  selector: 'app-change-employee-status',
  templateUrl: './change-employee-status.component.html',
  styleUrls: ['./change-employee-status.component.scss']
})
export class ChangeEmployeeStatusComponent extends SuperComponent implements OnInit ,AfterViewInit {

  allEmployeeStatus:any= [];
  employeeMenu:any= [];
  branches: any = []
  selectedRows: any[] = [];
selectedEmployeesIds: number[] = [];

  employeeWorkStatusMenu: [] =[];
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  constructor(Objects: ObjectsService, translate: TranslateService,private route: ActivatedRoute ,private EmployeeService:EmployeeService ,private router:Router,private publicSetting: publicSettingService, private NotifyService: NotifyService, gt: genericCustomStoreService) {
    super(Objects, translate, gt)
    this.gt.dropdown('Branch/GetDropDown').subscribe({
      next: (res: any) => {
        this.branches = res
      }
    })
  }

  ngOnInit(): void {
    debugger;
  this.getEmployeeWorkStatusDropDown();
    this.getAllEmployeeWorkStatus();
    
    

  }
onSelectionChanged(e: any) {
  this.selectedRows = e.selectedRowsData;
  this.selectedEmployeesIds = this.selectedRows.map((emp: any) => emp.id);

  console.log("Selected IDs:", this.selectedEmployeesIds);
}

sendoptions = {

    text: this.translate.instant('publicsettingnav.sendtomail'),
    type: 'success',
    onClick: () => {
      this.onSendClick();
    }
  }
 
  
   onSendClick(){
    // console.log("clicked")
debugger
     this.gt.$Ids.next(this.selectedEmployeesIds);

   


    const url = this.router.serializeUrl(this.router.createUrlTree([`/print-report`, encodeURIComponent('rpt_EmployeesInformations')]));
   // console.log(url)
   // window.open(url, '_blank');
   this.router.navigate([url]);

  }

  ngAfterViewInit(): void {
     this.gt.$filterstatus.subscribe((params:any) => {
    const status = params
    if (status !== undefined) {
      this.filterGridByStatus(status);
    }
  });
  }

  filterGridByStatus(status: number | string): void {
  if (status === undefined || status === null) {
    this.grid.instance.clearFilter();
    return;
  }
  this.grid.instance.filter(['employeeWorkStatus', '=', +status]);
}
  getAllEmployeeWorkStatus() {
 this.publicSetting.getAll('ChangeEmployeeStatus').subscribe((res:any)=> {
  console.log(res)
  res.forEach((element: any) => {
    element.dateOfHiring = element.dateOfHiring?.split('T')[0]
    element.endContractDate=element.endContractDate?.split('T')[0]
    element.resignationDate=element.resignationDate?.split('T')[0]
    element.approvalResignationDate=element.approvalResignationDate?.split('T')[0]
  });
  this.allEmployeeStatus= res;
   console.log("this.employeeStatus", this.allEmployeeStatus)
 })

  }
  getEmployeeWorkStatusDropDown() {
    this.gt.getdropdowndata('Employee/GetDropDown', 'EmployeeWorkStatus').subscribe((res: any) => {
      this.employeeWorkStatusMenu = res;
      console.log("work", this.employeeWorkStatusMenu)
    })
  }
  

  goToEmployeeStatus(e: any) {
    this.router.navigate(['/hr/changeStatus']);
    this.EmployeeService.$Status_ID.next(e.key ? e.key: 0)
    
  }
}
